import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Globe, Building2, Layers } from 'lucide-react';
import { mockData } from '../mock';
import { siteConfig } from '../config/site';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Hero */}
      <section className="relative pt-36 pb-24 lg:pt-44 lg:pb-32 border-b border-border">
        <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(11,31,58,0.04)_0%,rgba(184,148,31,0.06)_100%)]" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <p className="corporate-eyebrow mb-6">{siteConfig.companyName}</p>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-semibold mb-8 leading-[1.1] text-[#0B1F3A] dark:text-foreground">
              {mockData.hero.title}
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-3xl leading-relaxed">
              {mockData.hero.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button onClick={() => navigate('/vision')} className="btn-corporate-primary">
                {mockData.hero.cta1}
                <ArrowRight size={18} />
              </button>
              <button onClick={() => navigate('/financials')} className="btn-corporate-secondary">
                {mockData.hero.cta2}
                <ArrowRight size={18} />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="corporate-section bg-white dark:bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-14">
            <p className="corporate-eyebrow mb-3">Global Presence</p>
            <h2 className="text-3xl md:text-4xl font-semibold">Operating at Scale</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="corporate-card p-10 text-center">
              <Globe size={32} className="mx-auto mb-4 text-[#B8941F]" />
              <div className="stat-value mb-2">{mockData.stats.branches}</div>
              <div className="text-sm font-medium uppercase tracking-wide text-muted-foreground">Global Branches</div>
            </div>
            <div className="corporate-card p-10 text-center">
              <Layers size={32} className="mx-auto mb-4 text-[#B8941F]" />
              <div className="stat-value mb-2">{mockData.stats.industries}</div>
              <div className="text-sm font-medium uppercase tracking-wide text-muted-foreground">Industry Verticals</div>
            </div>
            <div className="corporate-card p-10 text-center">
              <Building2 size={32} className="mx-auto mb-4 text-[#B8941F]" />
              <div className="stat-value mb-2">{mockData.stats.companies}</div>
              <div className="text-sm font-medium uppercase tracking-wide text-muted-foreground">Portfolio Companies</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-[#0B1F3A] text-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Partnerships</p>
          <h2 className="text-3xl md:text-5xl font-semibold mb-6">Ready to Shape the Future?</h2>
          <p className="text-lg text-white/75 mb-10">
            Connect with our corporate team to explore strategic partnerships and investment opportunities.
          </p>
          <button
            onClick={() => navigate('/contact')}
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-[#0B1F3A] px-10 py-4 text-sm font-semibold uppercase tracking-wider hover:bg-[#c5a028] transition-colors"
          >
            Get in Touch
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
